import {
  MAX_ATTACHMENT_SIZE_BYTES,
  MAX_PENDING_ATTACHMENTS,
} from "./constants";
import {
  isAcceptableAttachmentFilename,
  isAcceptedAttachmentFilename,
} from "./fileType";
import { AttachmentValidationReason } from "./types";

type RejectedFile = {
  file: File;
  reason: AttachmentValidationReason;
};

export const takeAcceptedAttachmentFiles = (
  incoming: File[],
  currentCount: number,
): { accepted: File[]; rejected: RejectedFile[] } => {
  const accepted: File[] = [];
  const rejected: RejectedFile[] = [];
  let remaining = MAX_PENDING_ATTACHMENTS - currentCount;

  for (const file of incoming) {
    if (remaining <= 0) {
      rejected.push({ file, reason: "tooMany" });
      continue;
    }
    if (file.size <= 0) {
      rejected.push({ file, reason: "empty" });
      continue;
    }
    if (file.size > MAX_ATTACHMENT_SIZE_BYTES) {
      rejected.push({ file, reason: "tooLarge" });
      continue;
    }
    if (
      !isAcceptableAttachmentFilename(file.name) ||
      !isAcceptedAttachmentFilename(file.name)
    ) {
      rejected.push({ file, reason: "unsupportedType" });
      continue;
    }
    accepted.push(file);
    remaining -= 1;
  }

  return { accepted, rejected };
};
